import React from 'react';
import { ArrowRight } from 'lucide-react';
import useIsMobile from '../../../Hooks/useIsMobile';
import { isIOSDevice, isMobileBrowser, openInExternalBrowser, getImageRoot } from '../../../Utils/Utilities';

const AppDownloadBanner = () => {
  const isMobile = useIsMobile();
  const website = isMobileBrowser(); // True when visiting website from mobile browser (not native app/PWA)

  // Render ONLY when both website === true && isMobile === true
  if (!website || !isMobile) {
    return null;
  }

  const isIOS = isIOSDevice();
  const storeUrl = isIOS
    ? 'https://apps.apple.com/in/app/sahicrm/id6745503602'
    : 'https://play.google.com/store/apps/details?id=com.sahicrm.androidapp';

  const buttonText = isIOS ? 'Download on App Store' : 'Get it on Google Play';

  const handleDownloadClick = (e) => {
    e.stopPropagation();
    openInExternalBrowser(storeUrl);
  };

  return (
    <div className="px-4 mb-4">
      <div
        onClick={handleDownloadClick}
        className="bg-white rounded-xl p-4 transition-all cursor-pointer select-none active:scale-[0.99] flex flex-col gap-3 relative overflow-hidden"
      >
        {/* Subtle background highlight glow */}
        <div className="absolute top-0 right-0 w-24 h-24 bg-sahi-green-light/40 rounded-full blur-xl pointer-events-none -mr-6 -mt-6" />

        <div className="flex items-start justify-between gap-3 relative z-10">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-sahi-green-light/80 border border-sahi-green/20 flex items-center justify-center p-0.5 flex-shrink-0 shadow-sm overflow-hidden">
              <img
                src={getImageRoot('Images', 'SahiCRM_Short_dark.png')}
                alt="SahiClub App Icon"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h3 className="text-text-color text-base sm:text-lg font-bold leading-tight flex items-center gap-1.5">
                Get the SahiClub App
              </h3>
              <p className="text-xs text-sub-text-color mt-0.5 leading-relaxed">
                Manage your business faster, right at your fingertips.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-1 relative z-10">
          <button
            onClick={handleDownloadClick}
            className="w-full py-2.5 px-4 bg-sahi-primary-color hover:bg-[#084b18] text-white text-xs sm:text-sm font-semibold rounded-lg shadow-sm flex items-center justify-center gap-2 transition-colors active:scale-[0.98]"
          >
            <span>{buttonText}</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
